import styled from "styled-components"

import { ModalLayout } from "layouts/ModalLayout"

const StyledModalHeader = styled.div`
  display: flex;
  align-items: center;
  padding: 16px 16px 16px 20px;
  font-size: 18px;
  line-height: 24px;
  font-weight: 500;
  border-bottom: 1px solid #e2e8f0;
`

const ModalContentWrapper = styled.div`
  display: flex;
  max-height: calc(90vh - 50px);
  flex-direction: column;
  padding: 20px;

  h3,
  span {
    font-size: 14px;
    line-height: 20px;
    font-weight: 400;
  }

  h3 {
    color: #64748b;
  }

  span {
    color: #0f172a;
  }
`

const ModalContentSubheader = styled.div`
  display: flex;
  align-items: center;

  div {
    flex: 1;
  }
`

const ModalContentList = styled.div`
  max-height: 300px;
  min-height: 0px;
  overflow-y: auto;
`

const ModalContentRow = styled.div<{ count: number }>`
  display: flex;
  align-items: center;
  padding: 16px 0;
  border-bottom: ${({ count }) => (count > 1 ? "1px solid #e2e8f0" : "none")};
  font-size: 14px;

  &:last-child {
    border-bottom: none;
  }

  div {
    flex: 1;
  }
`

const TypeNameContainer = styled.div`
  font-size: 12px;
  display: flex;

  > div {
    background-color: #f1f5f9;
    flex: 0 0 auto;
    padding: 4px 8px;
    border-radius: 6px;
  }
`

interface CustomerMembershipTypesModalProps {
  onCancel: () => void
  membershipTypes: string[]
  currentCustomer: string
}

export const CustomerMembershipTypesModal = ({
  onCancel,
  membershipTypes,
  currentCustomer,
}: CustomerMembershipTypesModalProps) => (
  <ModalLayout width="375px" onClose={onCancel} isWithoutFooter>
    <StyledModalHeader>Membership types</StyledModalHeader>
    <ModalContentWrapper>
      <ModalContentSubheader>
        <div>
          <h3>Customer name</h3>
        </div>
        <div>
          <h3>Membership type</h3>
        </div>
      </ModalContentSubheader>
      <ModalContentList>
        {membershipTypes?.map(item => (
          <ModalContentRow key={item} count={membershipTypes?.length}>
            <div>{currentCustomer || "-"}</div>
            <TypeNameContainer>
              <div>{item}</div>
            </TypeNameContainer>
          </ModalContentRow>
        ))}
      </ModalContentList>
    </ModalContentWrapper>
  </ModalLayout>
)
